import { ApplicationConfig } from '@angular/core';
import { MAT_LUXON_DATE_ADAPTER_OPTIONS, provideLuxonDateAdapter } from '@angular/material-luxon-adapter';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { provideRouter, withInMemoryScrolling } from '@angular/router';

import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { MAT_RADIO_DEFAULT_OPTIONS } from '@angular/material/radio';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideAngularSvgIcon } from 'angular-svg-icon';
import { provideMatomo, withRouteData, withRouter } from 'ngx-matomo-client';
import { environment } from '../environments/environment';
import { authTokenInterceptor } from '../interceptors/auth-token.interceptor';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withInMemoryScrolling({scrollPositionRestoration: 'enabled'})),
    provideAnimationsAsync(),
    provideAngularSvgIcon(),
    provideHttpClient(withInterceptors([authTokenInterceptor])),
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'outline', floatLabel: 'always' },
    },
    {
      provide: MAT_LUXON_DATE_ADAPTER_OPTIONS,
      useValue: { useUtc: true },
    },
    provideLuxonDateAdapter(),
    {
      provide: 'env',
      useValue: 'environment',
    },
    provideMatomo({
      siteId: environment.MATOMO_SITE_ID,
      trackerUrl: environment.MATOMO_TRACKER_URL,
      acceptDoNotTrack: environment.MATOMO_ACCEPT_DO_NOT_TRACK === 'true' ? true : false,
    },
      withRouter(),
      withRouteData()),
    { provide: MAT_RADIO_DEFAULT_OPTIONS, useValue: { color: 'primary' } },
  ],
};
